module.exports = __webpack_public_path__ + "static/media/aircon.ca15b14e.png";